<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">Copyright 2022 © Pocket Box Ltd.</p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from "../data/menu";

  export default {
    name: "footerpage",
    data() {
      return {
        CompanyName: "",
        customizer: false,
        data:
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
    mounted() {
      var User = JSON.parse(localStorage.getItem("User"));
      this.Name = User.forename + " " + User.surname;
      var Company = JSON.parse(localStorage.getItem("Company"));
      this.CompanyName = Company.name;
    },
  };
</script>
